<template>
  <div class="ccard-container">
    <div class="header">
      <div>
        <span class="title">用户会员</span>
        <span class="des"></span>
      </div>
    </div>
    <div>
      <el-table
        v-loading="loading"
        :data="tableData"
        :cell-style="{ 'text-align': 'center' }"
        :header-cell-style="{background:'#F2F2F4', 'text-align': 'center' }"
        style="width: 100%"
      >
        <el-table-column prop="vipId" label="VIPID" width="80"></el-table-column>
        <el-table-column prop="vipName" label="VIP名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="type" label="卡面类型">
          <template #default="{ row }">
            <span>{{ row.type === 1 ? '正式卡' : '体验卡' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="vipName" label="首单优惠">
          <template #default="{ row }">
            <span>{{ row.isFirstOrderDiscountAvailable === 1 ? '未使用' : '已使用' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="startTime" label="开始时间"></el-table-column>
        <el-table-column prop="endTime" label="过期时间"></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>

export default {
  components: {},
  props: {
    id: String
  },
  data() {
    return {
      searchForm: {
        userId: ''
      },
      tableData: [],
      /*一共多少条数据*/
      total: 0,
      /*当前是第几页*/
      curPage: 1,
      /*一页多少条*/
      pageSize: 10,
      balance: 0,
      /*是否加载完成*/
      loading: true,
    }
  },
  mounted() {
    this.searchForm.userId = this.id
    this.fetchData()
  },
  methods: {
    fetchData() {
      let self = this
      let params = self.searchForm
      this.$http.get(`uVip/card`, {params}).then(({data}) => {
        this.tableData = data.data
      })
      self.loading = false
    },
  }
}
</script>
<style scoped lang="less">
.header {
  margin-top: 30px;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0;
}

.title {
  font-weight: bold;
  font-size: 16px;
  font-family: Source Han Sans CN;
}

.des {
  color: #909399;
  margin-left: 30px;
  font-size: 14px;
}

.pagination {
  text-align: center;
  margin-top: 20px;
}

::v-deep .el-dialog__body {
  padding-top: 10px;
}
</style>
